import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="topo-dark w-full border-y-4 border-ember bg-forest-deep" data-id="element-45" data-mp="1zyh2w7skw2x2">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center sm:py-20" data-id="element-46" data-mp="1uxjq6aqc812y">
        <h2 className="trail-underline font-display text-[34px] leading-tight text-paper sm:text-6xl" data-id="element-47" data-mp="1pz8cfowx96fg">
          Stop swapping boxes.{' '}
          <span className="text-ember" data-id="element-48" data-mp="1l16tr53er94i">Start proving faults.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-paper/80" data-id="element-49" data-mp="1g8x2nlqk430n">
          Every service call, from monitoring alert to warranty claim — for
          grid-tied, off-grid and hybrid systems, in the US, UK, Canada and
          Australia. Split the system, prove the fault, then fix it.
        </p>

        <div className="mt-7" data-id="element-50" data-mp="129xc28jhhe1u">
          <Countdown size="sm" tone="dark" data-id="element-51" data-mp="1295s5uz914re" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-ember bg-ember/10 px-5 py-4 text-left" data-id="element-52" data-mp="xa2mc8bg2uid">
          <div data-id="element-53" data-mp="3vdkcdp2dlfws">
            <span className="block font-mono text-[10px] font-bold uppercase tracking-widest text-ember" data-id="element-54" data-mp="40r5jpj29e8e">
              Complete pack
            </span>
            <span className="text-[15px] font-bold text-paper" data-id="element-55" data-mp="3lisf6mcpgv2j">
              Diagnostic Pro — 6 Volumes + 5 Bonuses
            </span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-56" data-mp="i0s4gzfrmbl8">
            <span className="text-[15px] text-paper/60 line-through" data-id="element-57" data-mp="i1a7cewxno24">$69</span>
            <span className="font-display text-5xl leading-none text-paper" data-id="element-58" data-mp="myag4xl634wx">
              $27
            </span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-59" data-mp="84ozzmxfy0v4">
          <CtaButton data-id="element-60" data-mp="d0e7qdjm6o2i">Yes, I want to prove it first — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-paper/65" data-id="element-61" data-mp="2ssaett3d97st">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-62" data-mp="1497ac8vq5meh">
                <span className="h-1.5 w-1.5 rounded-full bg-ember" data-id="element-63" data-mp="14aquiaki4hlj" />
                {item}
              </li>)}
        </ul>
      </div>
    </section>;
}